<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card class="py-5" elevation="8">
          <h1
            class="text-center primary--text text-h4"
            style="font-family: Kelly Slab !important"
          >
            Planos para o CPF/CNPJ {{ $store.state.cpf }}
          </h1>
          <h4 class="text-center">
            Data:
            {{
              new Date()
                .getDate()
                .toString()
                .padStart(2, "0")
            }}/ {{ (new Date().getMonth() + 1).toString().padStart(2, "0") }}/
            {{ new Date().getFullYear() }}
          </h4>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="fill-height">
      <v-col
        xs="12"
        v-for="(item, i) in ofertas"
        :key="i"
        class="d-flex flex-column"
      >
        <v-card class="mx-auto d-flex flex-column flex-grow-1" max-width="344">
          <v-list-item three-line class="flex-grow-1">
            <v-list-item-content>
              <div
                class="overline mb-2"
                style="font-family: Kelly Slab !important"
              >
                {{ credor }}
              </div>
              <v-list-item-subtitle class="mb-1">
                <div class="text--primary">
                  <b> Desconto de </b>
                </div>
              </v-list-item-subtitle>
              <v-list-item-subtitle class="mb-1">
                <div class="text--primary">
                  {{ Math.trunc((item.DiscountRate * 100).toFixed(2)) }}%
                </div>
              </v-list-item-subtitle>
              <v-list-item-title class="headline mb-1">{{
                item.DownPaymentAmount == 0 ? "A Vista" : "Parcelado"
              }}</v-list-item-title>
              <v-list-item-subtitle class="mb-1">
                <div class="text--primary" v-if="item.DownPaymentAmount > 0">
                  Entrada de R$ <b>{{ item.DownPaymentAmount | dinheiro }}</b>
                </div>
              </v-list-item-subtitle>
              <v-list-item-subtitle class="mb-1">
                <div class="text--primary" v-if="item.DownPaymentAmount > 0">
                  +
                </div>
              </v-list-item-subtitle>
              <v-list-item-subtitle class="mb-1">
                <div class="text--primary">
                  {{ item.TotalInstallments }}X de R$
                  <b>{{ item.InstallmentAmount | dinheiro }}</b>
                </div>
              </v-list-item-subtitle>
              <v-list-item-subtitle class="mb-1">
                <div class="text--primary">
                  Venc: <b> {{ item.ScheduleDate | dataF }} </b>
                </div>
              </v-list-item-subtitle>

              <!--  <v-list-item-subtitle class="mb-1">
                <div class="text--primary">
                  R$ {{ item.ArrangementDiscount | dinheiro }}
                </div>
              </v-list-item-subtitle> -->
            </v-list-item-content>
          </v-list-item>
          <v-card-actions class="mt-auto">
            <v-btn color="primary" @click="negociar(i)">
              Negociar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <!-- -->
    <v-row class="mt-8 mb-12 ">
      <v-col cols="12" md="12" lg="12">
        <v-card
          elevation="6"
          class="pa-6 text-center justify-center align-center  d-flex flex-column  atendimento-card"
        >
          <v-icon size="48" class="mb-3" color="blue">
            mdi-pin
          </v-icon>

          <h2 class="text-h5 font-weight-bold mb-3">
            Não gostou dessas ofertas?
          </h2>

          <p class="text-body-1 mb-5 atendimento-text ">
            Se não gostar dessas ofertas, nos procure em outro canal de
            atendimento. Nossa equipe poderá ajudar você com outras
            possibilidades.
          </p>
          <v-col mb-5>
            <v-btn
              min-width="60%"
              max-width="90%"
              large
              rounded
              color="green"
              dark
              elevation="3"
              class="px-8"
              @click="abrirCanalAtendimento('whatsapp')"
            >
              <v-icon left>
                mdi-whatsapp
              </v-icon>

              Falar pelo WhatsApp
            </v-btn>
            <br />
            <v-btn
              min-width="60%"
              max-width="90%"
              large
              rounded
              color="blue"
              dark
              elevation="3"
              class="px-8 mt-4 "
              @click="abrirCanalAtendimento('telefone')"
            >
              <v-icon left>
                mdi-phone
              </v-icon>

              Telefone: (21) 2206 - 4883
            </v-btn>
            <br />
            <v-btn
              min-width="60%"
              max-width="100%"
              large
              rounded
              color="grey"
              dark
              elevation="3"
              class="px-8 mt-4"
              @click="abrirCanalAtendimento('email')"
            >
              <v-icon left>
                mdi-email
              </v-icon>
              Email: boleto@easboleto.com.br
            </v-btn>
          </v-col>
        </v-card>
      </v-col>
    </v-row>
    <!--  -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import { api } from "@/conf/api";
import { atualizarLogNegoc } from "@/conf/logNegoc";

export default {
  name: "PlanoDivZero",
  data() {
    return {
      credor: "DIVZERO",
      ofertas: null,
      divida: {},
      overlay: false,
      contrato: null,
      cpf: null,
    };
  },
  filters: {
    dinheiro: function(value) {
      return parseFloat(value)
        .toFixed(2)
        .replace(".", ",");
    },
    dataF: function(d2) {
      let d = d2.substr(0, 10);
      return d.substr(8, 2) + "/" + d.substr(5, 2) + "/" + d.substr(0, 4);
    },
  },
  async beforeMount() {
    //console.log("entrou no before mount do plano divzero");
    this.credor = this.$store.state.credor_atual;
    this.divida = this.$store.state.divida_atual;
    console.log("divida atual", this.divida);
    let contrato = this.divida.contrato;
    let cpf = this.$store.state.cpf;
    this.contrato = contrato;
    this.cpf = cpf;
    let divzero = this.$store.state.dividas_divzero;
    let divida1 = divzero.filter(function(item) {
      return item.DebtNumber == contrato;
    });
    console.log("divida1", divida1);
    if (divida1.length === 0) {
      this.ofertas = [];
    } else {
      this.ofertas = divida1[0].ofertas;
    }

    if (this.ofertas && this.ofertas.length == 0) {
      return this.$router.push({ name: "ContatoPage" });
    }

    //console.log("ofertas", contrato, this.ofertasCliente);
  },

  methods: {
    async abrirCanalAtendimento(canal) {
      const canais = {
        whatsapp: "https://esycb.me/SITE",
        telefone: "tel:22064883",
        email:
          "mailto:boleto@easboleto.com.br?subject=Estive%20no%20site%20e%20quero%20negociar%20meu%20d%C3%A9bito!",
      };

      const destino = canais[canal];

      if (!destino) {
        return;
      }

      const logNegoc = this.$store.state.logNegoc;
      logNegoc.log_status = `cpf ${logNegoc.cpf} solicitou atendimento por ${canal}`;
      await atualizarLogNegoc(logNegoc);

      if (canal === "whatsapp") {
        window.open(destino, "_blank", "noopener,noreferrer");
        return;
      }

      window.location.href = destino;
    },
    abrirPdfBase64(base64) {
      // Se vier com prefixo: data:application/pdf;base64,...
      const base64Limpo = base64.replace(/^data:application\/pdf;base64,/, "");

      const byteCharacters = atob(base64Limpo);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], {
        type: "application/pdf",
      });

      const url = URL.createObjectURL(blob);

      window.open(url, "_self"); //, "_blank");

      // opcional: limpar depois
      setTimeout(() => URL.revokeObjectURL(url), 10000);
    },
    async negociar(index) {
      const userConfirmed = confirm("Você confirma essa negociação?");
      if (!userConfirmed) {
        return; // Se o usuário cancelar, sai da função
      }
      try {
        this.overlay = true;
        await this.$store.dispatch("marcaPacoteAtual", "divzero");
        console.log("of", this.ofertas[index]);
        let vezes = this.ofertas[index].TotalInstallments;
        let logNegoc = this.$store.state.logNegoc;
        logNegoc.log_status = `cpf ${logNegoc.cpf} pagará em entrada + ${vezes} vezes`;
        await atualizarLogNegoc(logNegoc);
        let rep1 = await api.post(
          "divzero/negociar/" + this.cpf + "/site",
          this.ofertas[index],
        );

        let rep2 = rep1.data;
        console.log("rep2", rep2);
        let boleto = await api.get("divzero/pegaboleto/" + this.cpf);
        // console.log("rep2", JSON.stringify(boleto, null, 2));
        //alert(index);
        this.abrirPdfBase64(boleto.data.NextInstallments[0].BilletPdfContent);
        // this.$router.push(this.$store.state.divida_atual.cpcgc);
        //this.$router.push("PlanoUnismg2");
        this.overlay = false;
      } catch (e) {
        console.log(e);
        this.$router.push({ name: "ErroPage" });
      }
    },
  },
};
</script>

<style scoped>
.atendimento-card {
  border-radius: 16px !important;
  border: 1px solid #eeeeee;
  transition: all 0.25s ease;
}

.atendimento-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12) !important;
}

.atendimento-text {
  color: #666;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}
</style>
